/**
 * TunnelTab - Tunnel management tab component for the agent drawer
 *
 * Provides Cloudflare tunnel configuration for Praetorian users.
 * Re-exports TunnelManagementTab content adapted for drawer context.
 */

import React from 'react';

import type { Agent } from '@/hooks/useAgents';
import { TunnelManagementTab } from '@/sections/agents/components/aegis-management/tunnel/TunnelManagementTab';

interface TunnelTabProps {
  agent: Agent;
  taskMonitoring: ReturnType<
    typeof import('@/sections/agents/hooks').useTaskMonitoring
  >;
  setSelectedTabValue: (value: string) => void;
  isDrawerOpen: boolean;
}

export const TunnelTab: React.FC<TunnelTabProps> = ({
  agent,
  taskMonitoring,
  setSelectedTabValue,
  isDrawerOpen,
}) => {
  return (
    <div className="flex h-full flex-col" data-testid="agent-drawer-tunnel-tab">
      <TunnelManagementTab
        agent={agent}
        taskMonitoring={taskMonitoring}
        setSelectedTabValue={setSelectedTabValue}
        isModalOpen={isDrawerOpen}
      />
    </div>
  );
};
